module.exports = __webpack_public_path__ + "img/zhuchkova.227893f0.jpg";